import React from "react";
import type { IconProps } from "./icon.types";

export function Download({ size = 24, ...props }: IconProps): React.ReactElement {
  return (
    <svg {...props} fill="none" height={size} viewBox="0 0 24 24" width={size}>
      <path
        d="M12 9v6m0 0l3-2m-3 2l-3-2m14 2a4 4 0 0 0-4.07-4A7.002 7.002 0 0 0 5.669 9.01A5 5 0 0 0 6 19h13a4 4 0 0 0 4-4"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </svg>
  );
}
